import axios from "axios"
import { getNodeBaseUrl } from "./utils"

export const postContact = async (data: { name: string; email: string; message: string }) => {
  const res = await axios.post(getNodeBaseUrl() + "/contact", data)
  return res.data
}
